import { z } from 'zod'

export const TaxRateSchema = z.object({
	id: z.string(),
	storeId: z.string(),
	accountId: z.string().nullable().optional(),
	name: z.string(),
	rate: z.number(),
	include: z.boolean().default(false),
	applyToShipping: z.boolean().default(false),
	countryCodes: z.array(z.string()).default([]),
	stateCodes: z.array(z.string()).default([]),
	createdAt: z.date().optional(),
	updatedAt: z.date().optional(),
})

export type TaxRateType = z.infer<typeof TaxRateSchema>

export const toTaxRateDto = (data: any): TaxRateType => {
	return TaxRateSchema.parse({
		...data,
		include: data.include ?? false,
		applyToShipping: data.applyToShipping ?? false,
		countryCodes: data.countryCodes ?? [],
		stateCodes: data.stateCodes ?? [],
	})
}

